"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFormCreator = exports.stageFormCreator = void 0;
const lang_1 = require("./lang");
const brackets_manager_1 = require("brackets-manager");
const stageTypes = ['single_elimination', 'double_elimination', 'round_robin'];
const roundRobinMode = ['simple', 'double'];
const roundRobinSeeds = ['groups.effort_balanced', 'groups.seed_optimized', 'groups.bracket_optimized'];
const eliminationOrderings = ['natural', 'reverse', 'half_shift', 'reverse_half_shift', 'pair_flip', 'inner_outer'];
const grandFinalTypes = ['none', 'simple', 'double'];
/**
 * Creates a DOM form to create different stages for the brackets-manager
 *
 * @param configuration HTML element IDs to render this form to
 * @param submitCallable Callback function - what should happen onClick on the forms submit button?
 */
function stageFormCreator(configuration, submitCallable) {
    const parent = document.getElementById(configuration.parent_id);
    if (null === parent)
        throw new DOMException('parent with ID: ' + configuration.parent_id + ' was not found!');
    createBaseMask(parent, configuration);
    const stageSelector = document.getElementById(configuration.html_stage_type_selector_id);
    if (null === stageSelector)
        throw new DOMException('somehow we could not create a select!');
    stageSelector.onchange = () => {
        removeMaskFields(parent);
        let stage;
        switch (stageSelector.value) {
            case 'round_robin':
                stage = 'round_robin';
                break;
            case 'double_elimination':
                stage = 'double_elimination';
                break;
            case 'single_elimination':
                stage = 'single_elimination';
                break;
            default:
                throw new DOMException('stage ' + stageSelector.value + ' seems to be not implemented yet.');
        }
        createMaskFields(configuration, stage, parent, submitCallable);
    };
    // We're creating a round_robin here by default cause its selected on first load.
    createMaskFields(configuration, 'single_elimination', parent, submitCallable);
}
exports.stageFormCreator = stageFormCreator;
/**
 * Creates a DOM form to update the current stage.
 *
 * @param configuration HTML element IDs to render this form to
 * @param changeCallable Callback function - what should happen onClick on the forms submit button?
 */
function updateFormCreator(configuration, changeCallable) {
    var _a, _b;
    const urlParams = new URLSearchParams(window.location.search);
    const id = (_a = urlParams.get('id')) !== null && _a !== void 0 ? _a : 0;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const storedBrackets = JSON.parse((_b = localStorage.getItem('brackets')) !== null && _b !== void 0 ? _b : '{}');
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const currentBracket = storedBrackets[id];
    const parent = document.getElementById(configuration.parent_id);
    if (null === parent)
        throw new DOMException('parent with ID: ' + configuration.parent_id + ' was not found!');
    createBaseMask(parent, configuration, true, false);
    const stageSelector = document.getElementById(configuration.html_stage_type_selector_id);
    if (null === stageSelector)
        throw new DOMException('somehow we could not create a select!');
    stageSelector.onchange = () => {
        removeMaskFields(parent);
        const stage = (stageSelector.value || 'single_elimination');
        createMaskFields(configuration, stage, parent, changeCallable, 'Edit');
    };
    const teamCountInput = document.getElementById(configuration.html_team_count_input_id);
    teamCountInput.oninput = () => {
        const stage = (stageSelector.value || 'single_elimination');
        applyForm(configuration, stage, changeCallable);
    };
    createMaskFields(configuration, currentBracket.stage[0].type, parent, changeCallable, 'Edit');
}
exports.updateFormCreator = updateFormCreator;
/**
 * Removes all fields of the mask which are not the name and the stage selector.
 *
 * @param parent The HTML parent to hold the elements.
 */
function removeMaskFields(parent) {
    [...parent.children]
        .filter(c => !c.classList.contains('base-input'))
        .forEach(c => c.remove());
}
/**
 * @param parent HTMLElement
 * @param configuration FormConfiguration
 * @param setDefaultValues Whether to set default values for the form
 * @param showTeamNamesInput Whether to show the input for team names
 */
function createBaseMask(parent, configuration, setDefaultValues = false, showTeamNamesInput = true) {
    var _a, _b;
    const urlParams = new URLSearchParams(window.location.search);
    const id = (_a = urlParams.get('id')) !== null && _a !== void 0 ? _a : 0;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const storedBrackets = JSON.parse((_b = localStorage.getItem('brackets')) !== null && _b !== void 0 ? _b : '{}');
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const currentBracket = storedBrackets[id];
    // Name
    createInput(parent, 'text', configuration.html_name_id, (0, lang_1.t)('form-creator.stage-name-label'), (0, lang_1.t)('form-creator.stage-name-placeholder'), setDefaultValues ? currentBracket.stage[0].name : undefined, undefined, 1, 'base-input');
    // Team names
    if (showTeamNamesInput) {
        createTextarea(parent, configuration.html_team_names_input_id, (0, lang_1.t)('form-creator.team-label'), (0, lang_1.t)('form-creator.team-label-placeholder'), undefined, 'base-input');
    }
    // or Team count
    createInput(parent, 'number', configuration.html_team_count_input_id, showTeamNamesInput ? (0, lang_1.t)('form-creator.team-count') : 'Team count', (0, lang_1.t)('form-creator.team-count-placeholder'), setDefaultValues ? currentBracket.participant.length.toString() : '', '1', undefined, 'base-input');
    // Stage selector
    createSelect(parent, configuration.html_stage_type_selector_id, (0, lang_1.t)('form-creator.stage-selector-label'), stageTypes, setDefaultValues ? currentBracket.stage[0].type : undefined, 'base-input');
}
/**
 * removing all fields of the mask which are not the name and the stage selector
 *
 * @param config HTML element IDs to render this form to
 * @param stage Which type of stage are we building?
 * @param parent The parent DOM
 * @param submitCallback the callable to call when the data got created
 * @param submitBtnText Text of the submit button
 */
function createMaskFields(config, stage, parent, submitCallback, submitBtnText) {
    switch (stage) {
        case 'round_robin':
            // Teams amount
            createInput(parent, 'number', config.html_group_id, (0, lang_1.t)('form-creator.group-label'), (0, lang_1.t)('form-creator.group-placeholder'), config.group_default_size.toString(), '1');
            // Seed ordering
            createSelect(parent, config.html_seed_order_id, (0, lang_1.t)('form-creator.seed-order-label'), roundRobinSeeds);
            // Round robin mode
            createSelect(parent, config.html_round_robin_mode_id, (0, lang_1.t)('form-creator.round-robin-mode-label'), roundRobinMode);
            break;
        case 'single_elimination':
            // Seed ordering
            createSelect(parent, config.html_seed_order_id, (0, lang_1.t)('form-creator.seed-order-label'), eliminationOrderings);
            // Consolation Final
            createInput(parent, 'checkbox', config.html_consolation_final_checkbox_id, (0, lang_1.t)('form-creator.consolation-final-label'));
            break;
        case 'double_elimination':
            // Consolation Final
            createInput(parent, 'checkbox', config.html_consolation_final_checkbox_id, (0, lang_1.t)('form-creator.consolation-final-label'));
            // Skip first round
            createInput(parent, 'checkbox', config.html_skip_first_round_checkbox_id, (0, lang_1.t)('form-creator.skip-first-round-label'));
            // Grand final types
            createSelect(parent, config.html_grand_final_type_id, (0, lang_1.t)('form-creator.grand-final-type-label'), grandFinalTypes);
            // Seed orders
            createTextarea(parent, config.html_double_elimination_seed_textarea_id, (0, lang_1.t)('form-creator.seed-order-label'), (0, lang_1.t)('form-creator.double-elimination-seed-order-placeholder'), 'natural');
            break;
        default:
            throw new DOMException(`stage ${stage} seems to be not implemented yet.`);
    }
    const submitBtnWrapper = document.createElement('div');
    const submitBtn = document.createElement('button');
    submitBtn.innerText = submitBtnText || (0, lang_1.t)('form-creator.submit');
    submitBtn.type = 'submit';
    submitBtnWrapper.appendChild(submitBtn);
    submitBtn.onclick = () => {
        applyForm(config, stage, submitCallback);
    };
    parent.appendChild(submitBtnWrapper);
}
/**
 * Apply a form when click on submit
 *
 * @param config HTML element IDs to render this form to
 * @param stage Which type of stage are we building?
 * @param submitCallback the callable to call when the data got created
 */
function applyForm(config, stage, submitCallback) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let payload;
    let teamNamesValue;
    switch (stage) {
        case 'round_robin':
            try {
                validateRoundRobin(config);
            }
            catch (e) {
                alert(e.message);
                return;
            }
            const roundRobinSettings = {
                seedOrdering: [
                    ((_a = document.getElementById(config.html_seed_order_id).value) !== null && _a !== void 0 ? _a : 'groups.effort_balanced'),
                ],
                roundRobinMode: ((_b = document.getElementById(config.html_round_robin_mode_id).value) !== null && _b !== void 0 ? _b : 'simple'),
                groupCount: parseInt((_c = document.getElementById(config.html_group_id).value) !== null && _c !== void 0 ? _c : '0'),
            };
            payload = {
                name: (_d = document.getElementById(config.html_name_id).value) !== null && _d !== void 0 ? _d : '',
                settings: roundRobinSettings,
                tournamentId: 0,
                type: stage,
            };
            teamNamesValue = (_e = document.getElementById(config.html_team_names_input_id)) === null || _e === void 0 ? void 0 : _e.value;
            if (teamNamesValue)
                payload.seeding = teamNamesValue.split(',');
            else {
                const teamCount = parseInt(document.getElementById(config.html_team_count_input_id).value);
                payload.seeding = Array.from({ length: teamCount }).map((_, i) => `Team ${i + 1}`);
                roundRobinSettings.size = brackets_manager_1.helpers.getNearestPowerOfTwo(teamCount);
            }
            break;
        case 'single_elimination':
            validateSingleElimination(config);
            const singleEliminationSettings = {
                seedOrdering: [
                    ((_f = document.getElementById(config.html_seed_order_id).value) !== null && _f !== void 0 ? _f : 'natural'),
                ],
                consolationFinal: document.getElementById(config.html_consolation_final_checkbox_id).checked,
            };
            payload = {
                name: (_g = document.getElementById(config.html_name_id).value) !== null && _g !== void 0 ? _g : '',
                settings: singleEliminationSettings,
                tournamentId: 0,
                type: stage,
            };
            teamNamesValue = (_h = document.getElementById(config.html_team_names_input_id)) === null || _h === void 0 ? void 0 : _h.value;
            if (teamNamesValue)
                payload.seeding = teamNamesValue.split(',');
            else {
                const teamCount = parseInt(document.getElementById(config.html_team_count_input_id).value);
                payload.seeding = Array.from({ length: teamCount }).map((_, i) => `Team ${i + 1}`);
                singleEliminationSettings.size = brackets_manager_1.helpers.getNearestPowerOfTwo(teamCount);
            }
            break;
        case 'double_elimination':
            validateDoubleElimination(config);
            const rawSeedOrder = document.getElementById(config.html_double_elimination_seed_textarea_id).value.split(',');
            const seedOrder = rawSeedOrder.map(order => order.trim());
            const doubleEliminationSettings = {
                seedOrdering: seedOrder,
                consolationFinal: document.getElementById(config.html_consolation_final_checkbox_id).checked,
                skipFirstRound: document.getElementById(config.html_skip_first_round_checkbox_id).checked,
                grandFinal: document.getElementById(config.html_grand_final_type_id).value,
            };
            payload = {
                name: (_j = document.getElementById(config.html_name_id).value) !== null && _j !== void 0 ? _j : '',
                settings: doubleEliminationSettings,
                tournamentId: 0,
                type: stage,
            };
            teamNamesValue = (_k = document.getElementById(config.html_team_names_input_id)) === null || _k === void 0 ? void 0 : _k.value;
            if (teamNamesValue)
                payload.seeding = teamNamesValue.split(',');
            else {
                const teamCount = parseInt(document.getElementById(config.html_team_count_input_id).value);
                payload.seeding = Array.from({ length: teamCount }).map((_, i) => `Team ${i + 1}`);
                doubleEliminationSettings.size = brackets_manager_1.helpers.getNearestPowerOfTwo(teamCount);
            }
            break;
        default:
            throw new DOMException(`stage ${stage} seems to be not implemented yet.`);
    }
    submitCallback(payload);
}
/**
 * validates everything for the double_elimination stage
 *
 * @param config FormConfig
 */
function validateDoubleElimination(config) {
    baseValidation(config);
    const grandFinalType = document.getElementById(config.html_grand_final_type_id).value;
    if (!grandFinalType || !grandFinalTypes.includes(grandFinalType))
        throw new DOMException('grand_final_type must be one of: ' + grandFinalTypes.toString());
    const orderings = document.getElementById(config.html_double_elimination_seed_textarea_id).value.split(',');
    orderings.forEach(value => {
        const ordering = value.trim();
        if (!eliminationOrderings.includes(ordering))
            throw new DOMException('elimination seed_ordering wrong found: ' + ordering + 'must be one of: ' + eliminationOrderings.toString());
    });
}
/**
 * validates everything for a single_elimination stage
 *
 * @param config FormConfiguration
 */
function validateSingleElimination(config) {
    baseValidation(config);
    const ordering = document.getElementById(config.html_seed_order_id).value;
    if (!ordering || !eliminationOrderings.includes(ordering))
        throw new DOMException('seed_ordering must be one of: ' + eliminationOrderings.toString());
}
/**
 * validates everything for a round_robin stage
 *
 * @param config FormConfiguration
 */
function validateRoundRobin(config) {
    baseValidation(config);
    const groupAmount = parseInt(document.getElementById(config.html_group_id).value);
    if (groupAmount <= 0)
        throw new DOMException('group_amount must be equal or bigger than 1');
    const ordering = document.getElementById(config.html_seed_order_id).value;
    if (!roundRobinSeeds.includes(ordering))
        throw new DOMException('seed_ordering must be one of ' + roundRobinSeeds.toString());
    const roundRobinMode = document.getElementById(config.html_round_robin_mode_id).value;
    if (!roundRobinMode.includes(roundRobinMode))
        throw new DOMException('round_robin_mode must be one of ' + roundRobinMode.toString());
}
/**
 * validates the field every specification has (name, teams and stage)
 *
 * @param config FormConfiguration
 */
function baseValidation(config) {
    var _a;
    const name = document.getElementById(config.html_name_id).value;
    if (!name || name === '')
        throw new DOMException('No name provided.');
    const teamNamesValue = (_a = document.getElementById(config.html_team_names_input_id)) === null || _a === void 0 ? void 0 : _a.value;
    const teams = teamNamesValue ? teamNamesValue.split(',') : [];
    const teamCount = teams.length || parseInt(document.getElementById(config.html_team_count_input_id).value);
    if (teamCount < 2)
        throw new DOMException('Invalid team amount provided.');
    const stageType = document.getElementById(config.html_stage_type_selector_id).value;
    if (!stageType && stageTypes.includes(stageType))
        throw new DOMException('Invalid stage.');
}
/**
 * @param parent the parent DOM element to render to
 * @param textareaId the id of the textarea
 * @param labelText the text for the label of the textarea
 * @param textareaPlaceholder the placeholder for the textarea
 * @param textareaDefaultValue the default value for the textarea - if NULL or UNDEFINED this is not set
 * @param className Class name to give to the wrapper
 */
function createTextarea(parent, textareaId, labelText, textareaPlaceholder, textareaDefaultValue, className) {
    const wrapper = document.createElement('div');
    const label = document.createElement('label');
    label.setAttribute('for', textareaId);
    label.innerText = labelText;
    const textarea = document.createElement('textarea');
    textarea.placeholder = textareaPlaceholder;
    textarea.id = textareaId;
    if (null !== textareaDefaultValue && undefined !== textareaDefaultValue)
        textarea.value = textareaDefaultValue;
    if (className)
        wrapper.classList.add(className);
    wrapper.appendChild(label);
    wrapper.appendChild(textarea);
    parent.appendChild(wrapper);
}
/**
 * @param parent parent to render the DOM to
 * @param inputType input type
 * @param inputId the id for the input
 * @param labelText the label text for the input
 * @param inputPlaceholder the placeholder for the input - if NULL or UNDEFINED this is not set
 * @param inputDefaultValue the default value for the input - if NULL or UNDEFINED this is not set
 * @param inputMinValue the min value for the input - if NULL or UNDEFINED this is not set
 * @param inputMinLengthValue the minLength value for the input - if NULL or UNDEFINED this is not set
 * @param className Class name to give to the wrapper
 */
function createInput(parent, inputType, inputId, labelText, inputPlaceholder, inputDefaultValue, inputMinValue, inputMinLengthValue, className) {
    const wrapper = document.createElement('div');
    const label = document.createElement('label');
    label.setAttribute('for', inputId);
    label.innerText = labelText;
    const input = document.createElement('input');
    input.type = inputType;
    input.id = inputId;
    if (null !== inputPlaceholder && undefined !== inputPlaceholder)
        input.placeholder = inputPlaceholder;
    if (null !== inputDefaultValue && undefined !== inputDefaultValue)
        input.value = inputDefaultValue;
    if (null !== inputMinValue && undefined !== inputMinValue)
        input.min = inputMinValue;
    if (null !== inputMinLengthValue && undefined !== inputMinLengthValue)
        input.minLength = inputMinLengthValue;
    if (className)
        wrapper.classList.add(className);
    wrapper.appendChild(label);
    wrapper.appendChild(input);
    parent.appendChild(wrapper);
}
/**
 * @param parent The wrapper to render the created DOM Elements to
 * @param selectId The ID of the generated select
 * @param labelText The text of the label for the generated select
 * @param options The options to display in select
 * @param selectedOption Which option should be selected by default
 * @param className Class name to give to the wrapper
 */
function createSelect(parent, selectId, labelText, options, selectedOption, className) {
    const wrapper = document.createElement('div');
    const label = document.createElement('label');
    label.setAttribute('for', selectId);
    label.innerText = labelText;
    const select = document.createElement('select');
    select.id = selectId;
    createOptions(select, options, selectedOption);
    if (className)
        wrapper.classList.add(className);
    wrapper.appendChild(label);
    wrapper.appendChild(select);
    parent.appendChild(wrapper);
}
/**
 * @param optionSwitch HTMLElement to add the options to
 * @param options string list of possible options
 * @param selectedOption Which option should be selected by default
 */
function createOptions(optionSwitch, options, selectedOption) {
    options.forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.innerText = option;
        if (option === selectedOption)
            optionElement.selected = true;
        optionSwitch.appendChild(optionElement);
    });
}
window.stageFormCreator = stageFormCreator;
window.updateFormCreator = updateFormCreator;
